import { Routes } from '@angular/router';
import { ExtranetComponent } from './layout/extranet/extranet.component';
import { guestGuard } from './shared/guards/guest/guest-guard.guard';
import { authGuard } from './shared/guards/auth/auth-guards.guard';
import { accountTypeGuard } from './shared/guards/account-type/account-type-guard.guard';
import { permissionsGuard } from './shared/guards/permissions/permissions-guard.guard';

export const routes: Routes = [
  {
    path: '',
    component: ExtranetComponent,
    canActivate: [guestGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'auth',
      },
      {
        path: 'auth',
        loadChildren: () =>
          import('./features/auth/auth.routes').then((m) => m.AuthRoutes),
      },
    ],
  },
  {
    path: 'user',
    canActivate: [authGuard],
    canActivateChild: [accountTypeGuard, permissionsGuard],
    loadChildren: () =>
      import('./features/user/user.routes').then((m) => m.UserRoutes),
    data: {
      accountType: 'USER',
    },
  },
  {
    path: 'admin',
    canActivate: [authGuard],
    canActivateChild: [accountTypeGuard, permissionsGuard],
    loadChildren: () =>
      import('./features/admin/admin.routes').then((m) => m.AdminRoutes),
    data: {
      accountType: 'ADMIN',
    },
  },
  {
    path: '**',
    redirectTo: '',
  },
];
